import React from 'react';
import { Tooltip } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
	myButton: {
		backgroundColor: '#ffffff',
		borderRadius: '5px',
		border: '1px solid #dcdcdc',
		cursor: 'pointer',
		color: '#666666',
		fontSize: '12px',
		padding: '0px 15px',
		position: 'relative',
		top: '-2px',
		left: '-23px',
	},
});

const ReturnIcon = ({ onClick = () => false, tooltip = 'Regresar' }) => {
	const classes = useStyles();
	return (
		<Tooltip title={tooltip}>
			<span>
				<button onClick={onClick} className={classes.myButton}>
					<ArrowBack />
					Regresar
				</button>
			</span>
		</Tooltip>
	);
};

export default ReturnIcon;
